import { api } from "@pharmupp/p3-front-commons"

export async function getDocSigningLink(endpoint: string) {
  const { link } = await api.get<{ link: string }>(endpoint)
  return link
}
